import React, { useEffect, useRef, useState } from "react";
import { classNames } from "primereact/utils";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";

import AppTopbar from "./AccountHomeTopbar";
import AppMenu from "./AccountLeftMenu";

import PrimeReact from "primereact/api";
import { Tooltip } from "primereact/tooltip";

import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import MyCompanies from "./MyCompanies";
import UnclaimedProfiles from "./admin/UnclaimedProfiles";
import AllProviders from "./admin/AllProviders";
import ProviderRecommendations from "./admin/recommendations/ProviderRecommendations";
import RecommendationSummary from "./admin/recommendations/RecommendationSummary";
import MyAccount from "./MyAccount";
import TokenService from "../../utils/TokenService";
import NewProvider from "./NewProvider";
import NewUnclaimedProfile from "./admin/NewUnclaimedProfile";
import AllUsers from "./admin/AllUsers";
import AllProfiles from "./admin/AllProfiles";
import FreeTrials from "./admin/FreeTrials";
import PaidSubscriptions from "./admin/PaidSubscriptions";
import CanceledSubscriptions from "./admin/CanceledSubscriptions";
import Promos from "./admin/Promos";
import UserEventLog from "./admin/UserEventLog";
import Events from "./admin/Events";
import AdminHome from "./admin/AdminHome";
import ExpiredFreeTrials from "./admin/ExpiredTrials";
import SuggestedOffers from "./admin/offers/SuggestedOffers";
import ServerMetrics from "./admin/ServerMetrics";
import MyReviews from "./MyReviews";
import MyFriends from "./MyFriends";
import AddFacebookFriends from "./AddFacebookFriends";
import NewUser from "./NewUser";
import ProviderEventLog from "./admin/ProvderEventLog";
import ImportCompanyData from "./admin/ImportCompanyData";
import AdminInvoices from "./admin/AdminInvoices";
import AdminEstimates from "./admin/AdminEstimates";
import { ACCOUNT_PLAN, ACTIVITY_LOG_REPORT, BILLING_SETTINGS, CAMPAIGNS, CLIENT_COMMUNICATION_SETTINGS, CLIENTS, COMPANY_SETTINGS, CONVERSATIONS, ESTIMATES, INVOICES, JOB_SETTINGS, JOB_WORKFLOW, JOBS, MEDIA_LIBRARY, MESSENGER_SETTINGS, PAYMENT_REPORT, PRICE_BOOK, REQUESTS, SALES_REPORT, STRIPE_SETTINGS, SUBSCRIPTIONS, TAGS, TASKS, TAX_RATES, TAX_REPORT, USERS, VIEW } from "../../utils/Permissions";
export const RTLContext = React.createContext();

const AccountHome = () => {
    const menuMode = "static";
    const [desktopMenuActive, setDesktopMenuActive] = useState(true);
    const [mobileMenuActive, setMobileMenuActive] = useState(false);
    const [activeTopbarItem, setActiveTopbarItem] = useState(null);
    const [menuActive, setMenuActive] = useState(false);
    const inputStyle = "outlined";
    const isRTL = false;
    const ripple = true;
    const [mobileTopbarActive, setMobileTopbarActive] = useState(false);
    const menuTheme = "light";
    const topbarTheme = "cyan";
    const [inlineMenuActive, setInlineMenuActive] = useState({});
    const [searchActive, setSearchActive] = useState(false);
    const copyTooltipRef = useRef();
    let currentInlineMenuKey = useRef(null);
    const location = useLocation();
    const navigate = useNavigate();
    const [menu, setMenu] = useState(null);

    PrimeReact.ripple = true;

    let searchClick;
    let topbarItemClick;
    let menuClick;
    let inlineMenuClick;

    const loadMenu = async () => {
        const separatorMenu = {
            separator: true
        }
        const menuItems = [];
        if (TokenService.getProviderSubdomain()) {
            let providerAppUrl = TokenService.getProviderAppUrl();
            const providerOverview = {
                label: TokenService.getProviderName(),
                isCollapsable: false,
                to: providerAppUrl + "/dashboard"
            };
            menuItems.push(providerOverview);
            const promoteMenu = {
                label: "Promote",
                icon: "pi pi-megaphone",
                items: []
            };
            const companyProfileMenu = {
                label: "Public Profile",
                to: TokenService.getProfileUrl()
            };
            promoteMenu.items.push(companyProfileMenu);
            const profileUrlMenu = {
                label: "Profile URL",
                to: providerAppUrl + "/settings/public-profile",
            };
            promoteMenu.items.push(profileUrlMenu);
            if (await TokenService.isAuthorized(CAMPAIGNS, VIEW)) {
                const campaignsMenu = {
                    to: providerAppUrl + "/marketing/campaigns",
                    label: "Campaigns",
                };
                promoteMenu.items.push(campaignsMenu);
            }
            menuItems.push(promoteMenu);

            const operateMenu = {
                label: "Operate",
                icon: "pi pi-truck",
                items: []
            };

            const dashboardMenu = {
                to: providerAppUrl,
                label: "Dashboard",
            };
            operateMenu.items.push(dashboardMenu);
            if (await TokenService.isAuthorized(JOBS, VIEW)
                || await TokenService.isAuthorized(JOB_WORKFLOW, VIEW)
                || await TokenService.isAuthorized(TASKS, VIEW)
                || await TokenService.isAuthorized(REQUESTS, VIEW)
            ) {
                const scheduleMenu = {
                    label: "Schedule",
                    to: providerAppUrl + "/schedule",
                };
                operateMenu.items.push(scheduleMenu);
            }
            if (await TokenService.isAuthorized(CLIENTS, VIEW)) {
                const clientsMenu = {
                    label: "Clients",
                    to: providerAppUrl + "/clients",
                };
                operateMenu.items.push(clientsMenu);
            }
            if (await TokenService.isAuthorized(REQUESTS, VIEW)) {
                const requestsMenu = {
                    label: "Requests",
                    to: providerAppUrl + "/requests",
                };
                operateMenu.items.push(requestsMenu);
            }
            if (await TokenService.isAuthorized(ESTIMATES, VIEW)) {
                const estimatesMenu = {
                    to: providerAppUrl + "/estimates",
                    label: "Estimates",
                };
                operateMenu.items.push(estimatesMenu);
            }
            if (await TokenService.isAuthorized(JOBS, VIEW)) {
                const jobsMenu = {
                    label: "Jobs",
                    to: providerAppUrl + "/jobs",
                };
                operateMenu.items.push(jobsMenu);
            }
            if (await TokenService.isAuthorized(TASKS, VIEW)) {
                const tasksMenu = {
                    label: "Tasks",
                    to: providerAppUrl + "/tasks",
                };
                operateMenu.items.push(tasksMenu);
            }
            if (await TokenService.isAuthorized(INVOICES, VIEW)) {
                const invoicesMenu = {
                    label: "Invoices",
                    to: providerAppUrl + "/invoices",
                };
                operateMenu.items.push(invoicesMenu);
            }
            if (await TokenService.isAuthorized(SUBSCRIPTIONS, VIEW)) {
                const subscriptionsMenu = {
                    label: "Subscriptions",
                    to: providerAppUrl + "/subscriptions",
                };
                operateMenu.items.push(subscriptionsMenu);
            }
            if (await TokenService.isAuthorized(PRICE_BOOK, VIEW)) {
                const itemsMenu = {
                    label: "Price Book",
                    to: providerAppUrl + "/price-book",
                };
                operateMenu.items.push(itemsMenu);
            }
            menuItems.push(operateMenu);
            if (await TokenService.isAuthorized(CONVERSATIONS, VIEW)) {
                const engageMenu = {
                    label: "Engage",
                    icon: "pi pi-comments",
                    items: []
                };
                const engageOverviewMenu = {
                    to: providerAppUrl + "/engage/overview",
                    label: "Overview",
                };
                engageMenu.items.push(engageOverviewMenu);
                const messengerMenu = {
                    label: "Messenger",
                    to: providerAppUrl + "/engage/overview?engage=open",
                };
                engageMenu.items.push(messengerMenu);
                if (await TokenService.isAuthorized(MESSENGER_SETTINGS, VIEW)) {
                    engageMenu.items.push({ label: "Phone Numbers", to: providerAppUrl + "/engage/phone-numbers" });
                    engageMenu.items.push({ label: "Email Addresses", to: providerAppUrl + "/engage/email-addresses" });
                }
                menuItems.push(engageMenu);
            }
            if (await TokenService.isAuthorized(COMPANY_SETTINGS, VIEW)
                || await TokenService.isAuthorized(STRIPE_SETTINGS, VIEW)
                || await TokenService.isAuthorized(BILLING_SETTINGS, VIEW)
                || await TokenService.isAuthorized(TAX_RATES, VIEW)
                || await TokenService.isAuthorized(CLIENT_COMMUNICATION_SETTINGS, VIEW)
                || await TokenService.isAuthorized(MEDIA_LIBRARY, VIEW)
                || await TokenService.isAuthorized(JOB_SETTINGS, VIEW)
                || await TokenService.isAuthorized(TAGS, VIEW)) {
                const settingsMenu = {
                    label: "Settings",
                    icon: "pi pi-wrench",
                    items: [
                        // { label: "Invoices", icon: "pi pi-file-o", to: "/provider/" + providerSub + "/settings/invoices" },
                        // { label: "Taxes", icon: "pi pi-percentage", to: "/provider/" + providerSub + "/settings/taxes" },
                        // { label: "Quickbooks", icon: "pi pi-sync", to: "/provider/" + providerSub + "/settings/quickbooks" },
                    ],
                };
                if (await TokenService.isAuthorized(COMPANY_SETTINGS, VIEW)) {
                    settingsMenu.items.push({ label: "Company Settings", to: providerAppUrl + "/settings/company" });
                }
                if (await TokenService.isAuthorized(STRIPE_SETTINGS, VIEW)) {
                    settingsMenu.items.push({ label: "Stripe Integration", to: providerAppUrl + "/settings/stripe-integration" });
                }
                if (await TokenService.isAuthorized(BILLING_SETTINGS, VIEW)) {
                    settingsMenu.items.push({ label: "Billing Settings", to: providerAppUrl + "/settings/billing" });
                }
                if (await TokenService.isAuthorized(TAX_RATES, VIEW)) {
                    settingsMenu.items.push({ label: "Tax Rates", to: providerAppUrl + "/settings/tax-rates" });
                }
                if (await TokenService.isAuthorized(CLIENT_COMMUNICATION_SETTINGS, VIEW)) {
                    settingsMenu.items.push({ label: "Client Communication", to: providerAppUrl + "/settings/client-communication" });
                }
                if (await TokenService.isAuthorized(MEDIA_LIBRARY, VIEW)) {
                    settingsMenu.items.push({ label: "Media Library", to: providerAppUrl + "/settings/media-library" });
                }
                if (await TokenService.isAuthorized(JOB_SETTINGS, VIEW)) {
                    settingsMenu.items.push({ label: "Job Settings", to: providerAppUrl + "/settings/jobs" });
                }
                if (await TokenService.isAuthorized(TAGS, VIEW)) {
                    settingsMenu.items.push({ label: "Tags", to: providerAppUrl + "/settings/tags" });
                }
                // settingsMenu.items.push({ label: "Job Forms", to: "/provider/" + providerSub + "/job-forms" });
                menuItems.push(settingsMenu);
            }
            if (await TokenService.isAuthorized(SALES_REPORT, VIEW)
                || await TokenService.isAuthorized(PAYMENT_REPORT, VIEW)
                || await TokenService.isAuthorized(TAX_REPORT, VIEW)
                || await TokenService.isAuthorized(ACTIVITY_LOG_REPORT, VIEW)) {
                const reportsMenu = {
                    label: "Reports",
                    icon: "pi pi-chart-line",
                    items: []
                };
                if (await TokenService.isAuthorized(TAX_REPORT, VIEW)) {
                    reportsMenu.items.push({ label: "Tax Report", to: providerAppUrl + "/reports/tax-report" });
                }
                if (await TokenService.isAuthorized(PAYMENT_REPORT, VIEW)) {
                    reportsMenu.items.push({ label: "Payment Report", to: providerAppUrl + "/reports/payment-report" });
                }
                if (await TokenService.isAuthorized(SALES_REPORT, VIEW)) {
                    reportsMenu.items.push({ label: "Sales Report", to: providerAppUrl + "/reports/sales-report" });
                }
                if (await TokenService.isAuthorized(ACTIVITY_LOG_REPORT, VIEW)) {
                    reportsMenu.items.push({ label: "Activity Log", to: providerAppUrl + "/reports/activity-log" });
                }
                menuItems.push(reportsMenu);
            }
            if (await TokenService.isAuthorized(USERS, VIEW)) {
                const securityMenu = {
                    label: "Security",
                    icon: "pi pi-lock",
                    items: [
                        { label: "Users", to: providerAppUrl + "/security/users" },
                    ],
                };
                menuItems.push(securityMenu);
            }
            if (await TokenService.isAuthorized(ACCOUNT_PLAN, VIEW)) {
                const planMenu = {
                    label: "Plan",
                    icon: "pi pi-link",
                    to: providerAppUrl + "/account/plan"
                };
                menuItems.push(planMenu);
            }
            menuItems.push(separatorMenu);
        }
        const findProvidersMenu = {
            label: "Find a Pro",
            icon: "pi pi-search",
            to: process.env.REACT_APP_PUBLIC_SITE + "/search"
        };
        menuItems.push(findProvidersMenu);
        const businessSiteMenu = {
            label: "Businesses",
            icon: "pi pi-lightbulb",
            items: [
                {
                    label: "Promote",
                    to: process.env.REACT_APP_BUSINESS_SITE + "/promote"
                },
                {
                    label: "Operate",
                    to: process.env.REACT_APP_BUSINESS_SITE + "/features/field-service-management"
                },
                {
                    label: "Engage",
                    to: process.env.REACT_APP_BUSINESS_SITE + "/engage"
                },
                {
                    label: "Pricing",
                    to: process.env.REACT_APP_BUSINESS_SITE + "/pricing"
                }
            ]
        };
        menuItems.push(businessSiteMenu);
        menuItems.push(separatorMenu);
        const accountMenu = {
            label: "Account",
            icon: "pi pi-user",
            items: [],
        };
        const myCompaniesMenu = {
            to: "/account/select-provider",
            label: "My Companies",
        };
        accountMenu.items.push(myCompaniesMenu);
        const myAccountMenu = {
            to: "/account/profile",
            label: "My Account",
        };
        accountMenu.items.push(myAccountMenu);
        const myReviewsMenu = {
            to: "/account/my-reviews",
            label: "My Reviews",
        };
        accountMenu.items.push(myReviewsMenu);
        const myFriendsMenu = {
            to: "/account/my-friends",
            label: "My Friends",
        };
        accountMenu.items.push(myFriendsMenu);
        const logoutMenu = {
            label: "Logout " + TokenService.getUserName(),
            url: "/logout",
        };
        accountMenu.items.push(logoutMenu);
        menuItems.push(accountMenu);
        if (TokenService.isWallistAdmin()) {
            menuItems.push(separatorMenu);
            const wallistAdminMenu = {
                label: "Wallist Administration",
                icon: "pi pi-cog",
                items: []
            };
            const adminHomeMenu = {
                to: "/account/admin/home",
                label: "Admin Home",
            };
            wallistAdminMenu.items.push(adminHomeMenu);
            menuItems.push(wallistAdminMenu);
        }
        const m = [{ items: menuItems }];
        m.concat(...m, menuItems);
        setMenu(m);
    }
    useEffect(() => {
        loadMenu();
    }, []);

    useEffect(() => {
        copyTooltipRef && copyTooltipRef.current && copyTooltipRef.current.updateTargetEvents();

        const verifyUser = () => {
            if (!TokenService.isLoggedIn()) {
                navigate("/");
            }
        };
        verifyUser();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);

    useEffect(() => {
        if (menuMode === "overlay") {
            hideOverlayMenu();
        }
        if (menuMode === "static") {
            setDesktopMenuActive(true);
        }
    }, [menuMode]);

    const onMenuClick = (event) => {
        menuClick = true;
    };

    useEffect(() => {
        window.addEventListener("resize", function (event) {
            if (isDesktop()) {
                setDesktopMenuActive(true);
            }
        });
    }, []);

    const onMenuButtonClick = (event) => {
        menuClick = true;

        if (isDesktop()) setDesktopMenuActive((prevState) => !prevState);
        else setMobileMenuActive((prevState) => !prevState);

        event.preventDefault();
    };

    const onTopbarItemClick = (event) => {
        topbarItemClick = true;
        if (activeTopbarItem === event.item) setActiveTopbarItem(null);
        else {
            setActiveTopbarItem(event.item);
        }

        event.originalEvent.preventDefault();
    };

    const onSearch = (event) => {
        searchClick = true;
        setSearchActive(event);
    };

    const onMenuItemClick = (event) => {
        if (!event.item.items && (menuMode === "overlay" || !isDesktop())) {
            hideOverlayMenu();
        }

        if (!event.item.items && (isHorizontal() || isSlim())) {
            setMenuActive(false);
        }
    };

    const onRootMenuItemClick = (event) => {
        setMenuActive((prevState) => !prevState);
    };

    const onMobileTopbarButtonClick = (event) => {
        setMobileTopbarActive((prevState) => !prevState);
        event.preventDefault();
    };

    const onDocumentClick = (event) => {
        if (!searchClick && event.target.localName !== "input") {
            setSearchActive(false);
        }

        if (!topbarItemClick) {
            setActiveTopbarItem(null);
        }

        if (!menuClick && (menuMode === "overlay" || !isDesktop())) {
            if (isHorizontal() || isSlim()) {
                setMenuActive(false);
            }
            hideOverlayMenu();
        }

        if (inlineMenuActive[currentInlineMenuKey.current] && !inlineMenuClick) {
            let menuKeys = { ...inlineMenuActive };
            menuKeys[currentInlineMenuKey.current] = false;
            setInlineMenuActive(menuKeys);
        }

        if (!menuClick && (isSlim() || isHorizontal())) {
            setMenuActive(false);
        }

        searchClick = false;
        topbarItemClick = false;
        inlineMenuClick = false;
        menuClick = false;
    };

    const hideOverlayMenu = () => {
        setMobileMenuActive(false);
        setDesktopMenuActive(false);
    };

    const isDesktop = () => {
        return window.innerWidth > 991;
    };

    const isHorizontal = () => {
        return menuMode === "horizontal";
    };

    const isSlim = () => {
        return menuMode === "slim";
    };

    const layoutContainerClassName = classNames(
        "layout-wrapper ",
        "layout-menu-" + menuTheme + " layout-topbar-" + topbarTheme,
        {
            "layout-menu-static": menuMode === "static",
            "layout-menu-overlay": menuMode === "overlay",
            "layout-menu-slim": menuMode === "slim",
            "layout-menu-horizontal": menuMode === "horizontal",
            "layout-menu-active": desktopMenuActive,
            "layout-menu-mobile-active": mobileMenuActive,
            "layout-topbar-mobile-active": mobileTopbarActive,
            "p-input-filled": inputStyle === "filled",
            "p-ripple-disabled": !ripple,
            "layout-rtl": isRTL,
        }
    );
    return (
        <RTLContext.Provider value={isRTL}>
            <div className={layoutContainerClassName} onClick={onDocumentClick}>
                <Tooltip
                    ref={copyTooltipRef}
                    target=".block-action-copy"
                    position="bottom"
                    content="Copied to clipboard"
                    event="focus"
                />

                <AppTopbar
                    horizontal={isHorizontal()}
                    activeTopbarItem={activeTopbarItem}
                    onMenuButtonClick={onMenuButtonClick}
                    onTopbarItemClick={onTopbarItemClick}
                    onMobileTopbarButtonClick={onMobileTopbarButtonClick}
                    mobileTopbarActive={mobileTopbarActive}
                    searchActive={searchActive}
                    onSearch={onSearch}
                />

                <div className="menu-wrapper" onClick={onMenuClick}>
                    <div className="layout-menu-container">
                        <AppMenu
                            model={menu}
                            onMenuItemClick={onMenuItemClick}
                            onRootMenuItemClick={onRootMenuItemClick}
                            menuMode={menuMode}
                            active={menuActive}
                            currentPath={location.pathname}
                        />
                        {/* <div className="block lg:hidden">
                            <hr className="mb-0 pb-0" />
                            <div className="pt-4 ml-4 p-1">Logged in as:<br />{TokenService.getUserName()}</div>
                        </div> */}
                    </div>
                </div>

                <div className="layout-main">
                    <div>
                        <Routes>
                            <Route path="welcome" element={<NewUser />} />
                            <Route path="profile" element={<MyAccount />} />
                            <Route path="my-reviews" element={<MyReviews />} />
                            <Route path="my-friends" element={<MyFriends />} />
                            {/* <Route path="add-facebook-friends" element={<AddFacebookFriends />} /> */}
                            <Route path="select-provider" element={<MyCompanies />} />
                            <Route path="new-provider" element={<NewProvider />} />
                            <Route path="admin/unclaimed-profiles" element={<UnclaimedProfiles />} />
                            <Route path="admin/new-profile" element={<NewUnclaimedProfile />} />
                            <Route path="admin/all-providers" element={<AllProviders />} />
                            <Route path="admin/provider-recommendations" element={<ProviderRecommendations />} />
                            <Route path="admin/recommendation-summary" element={<RecommendationSummary />} />
                            <Route path="admin/all-profiles" element={<AllProfiles />} />
                            <Route path="admin/all-users" element={<AllUsers />} />
                            <Route path="admin/free-trials" element={<FreeTrials />} />
                            <Route path="admin/expired-free-trials" element={<ExpiredFreeTrials />} />
                            <Route path="admin/subscriptions" element={<PaidSubscriptions />} />
                            <Route path="admin/canceled-subscriptions" element={<CanceledSubscriptions />} />
                            <Route path="admin/promos" element={<Promos />} />
                            <Route path="admin/user-events" element={<UserEventLog />} />
                            <Route path="admin/provider-events" element={<ProviderEventLog />} />
                            <Route path="admin/events" element={<Events />} />
                            <Route path="admin/home" element={<AdminHome />} />
                            <Route path="admin/server-metrics" element={<ServerMetrics />} />
                            <Route path="admin/offers/suggested" element={<SuggestedOffers />} />
                            <Route path="admin/import-company" element={<ImportCompanyData />} />
                            <Route path="admin/invoices" element={<AdminInvoices />} />
                            <Route path="admin/estimates" element={<AdminEstimates />} />
                        </Routes>
                    </div>
                </div>

                {mobileMenuActive && <div className="layout-mask modal-in"></div>}
            </div>
        </RTLContext.Provider>
    );
};

export default AccountHome;
